<template>
    <ValidationProvider
        :rules="rules"
        v-slot="v"
    >
        <div class="flex items-start mt-4">
            <div class="absolute flex items-center h-5">
                <input
                    type="checkbox"
                    :id="label"
                    :checked="value"
                    @change="changeHandler"
                    :class="v.errors[0] ? 'bg-pink-200' : ''"
                    :value="value == true ? 'checked' : null"
                    class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                />
            </div>
            <div class="pl-7 text-sm leading-5">
                <label :for="label" class="font-medium text-gray-700">
                    {{ label }}
                    <button
                        v-show="descriptiontoggle"
                        @click="showdescription = !showdescription"
                        type="button"
                        class="ml-2 inline-flex items-center px-1.5 py-0.5 border border-transparent text-xs leading-4 font-light rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-150"
                    >{{ showdescription ? 'Ausblenden' : 'Einblenden' }}</button>
                    <span
                        class="ml-2 text-xs text-red-500"
                        v-if="v.errors[0]"
                    >{{ v.errors[0] }}</span>
                </label>
                <transition name="fade">
                    <p
                        v-show="(!descriptiontoggle || showdescription) && description && description != ''"
                        class="text-gray-500 mt-4 mb-2"
                    >{{ description }}</p>
                </transition>
            </div>
        </div>
    </ValidationProvider>
</template>

<script>
export default {
    name: 'check-box',
    props: {
        label: String,
        description: String,
        value: Boolean,
        descriptiontoggle: Boolean,
        rules: String,
    },

    data: function() {
        return {
            showdescription: false,
        }
    },

    computed: {},

    methods: {
        changeHandler() {
            this.$emit('input', !this.value)
        },
    },
}
</script>

<style scoped>
[data-tooltip]:hover {
    position: relative;
}
[data-tooltip]:hover::before {
    all: initial;
    font-family: Arial, Helvetica, sans-serif;
    display: inline-block;
    border-radius: 5px;
    padding: 10px;
    background-color: #777;
    content: attr(data-tooltip);
    color: #f9f9f9;
    position: absolute;
    bottom: 100%;
    width: 300px;
    left: 50%;
    transform: translate(-50%, 0);
    margin-bottom: 15px;
    text-align: center;
    font-size: 14px;
}
</style>